import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
const pathPrefix = '/organization';

export const organizationContract = c.router(
  {
    debugAddCredits: {
      method: 'GET',
      path: '/credits/add-debug',
      responses: {
        200: z.any(),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
